import _ from 'lodash';

import { adminClient as apolloClient } from '@/store/apollo';

import SaveDashboardGql from '@/store/graphql/system/mutations/SaveDashboard.gql';

export default {
    save: function (cmsId, layout, trialOnboardingContent, infoBoardContents, removeInfoBoardIds) {
        if (cmsId === undefined) throw new Error('required argument cmsId is missing');

        var variables = {
            cms_id: parseInt(cmsId),
        };

        if (layout) {
            variables.layout = _.removeDeepByKey(layout, '__typename');
        }

        if (trialOnboardingContent) {
            variables.trial_onboarding_content = _.removeDeepByKey(trialOnboardingContent, '__typename');
        }

        if (infoBoardContents) {
            variables.info_board_contents = infoBoardContents.map(function (content) {
                return _.removeDeepByKey(content, '__typename');
            });
        }

        if (removeInfoBoardIds && removeInfoBoardIds.length) {
            variables.remove_info_board_ids = removeInfoBoardIds;
        }

        return new Promise(function (resolve, reject) {
            apolloClient
                .mutate({
                    mutation: SaveDashboardGql,
                    variables: variables
                })
                .then(function (result) {
                    apolloClient.clearStore();
                    resolve(result.data.SaveDashboard);
                })
                .catch(function (error) { reject(error); });
        });
    }
};
